<template>
  <m-form-base
    :id="id2"
    :label="label"
    :label-width="labelWidth"
    :label-position="labelPosition"
    :errormsg="errormsg2"
  >
    <v-menu v-model="menu" :close-on-content-click="false" offset-y min-width="290px">
      <!-- transition="scale-transition" -->
      <template v-slot:activator="{ on }">
        <div v-on="on" class="m-form-select">
          <input
            type="text"
            ref="myinput"
            :readonly="readonly"
            :autocomplete="autocomplete"
            :disabled="disabled"
            :value="rawdate"
            @focus="onfocus"
            @input="rawdate = $event.target.value"
            :id="id2"
          />
          <div class="m-form-base__picker">
            <v-icon>mdi-calendar</v-icon>
          </div>
        </div>
        <!-- <m-form-text
        v-model="date"
        :label="label"
        :label-width="labelWidth"
        :prefix="prefix"
        :prepend-icon="prependIcon"
        :readonly="readonly"
        v-on="on"
        ></m-form-text>-->
      </template>
      <v-date-picker :first-day-of-week="1" v-model="date" no-title @input="menu=false"></v-date-picker>
    </v-menu>
  </m-form-base>
</template>

<script>
import MFormBase from "./MFormBase";

export default {
  name: "mformdate",
  extends: MFormBase,
  props: {
    id: {
      default: "",
      type: String
    },
    value: String,
    prefix: String,
    autocomplete: {
      default: "new-password",
      type: String
    },
    readonly: {
      default: true,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    rules: {
      default: function() {
        return [];
      },
      type: Array
    }
  },
  mounted() {
    if (!this.id2) this.id2 = this.$Utils.randomstring();
    if (this.value) this.setValue(this.value);
  },
  data() {
    let date = this.$moment().format("YYYY-MM-DD");
    if (this.value) date = this.value;
    if (date == "0000-00-00") date = "";
    return {
      id2: this.id,
      errormsg2: "",
      rawdate: "",
      date,
      menu: false
    };
  },
  watch: {
    date: function(val) {
      this.$emit("input", val);
    },
    value: function(val) {
      this.setValue(val);
    }
  },
  components: {},
  methods: {
    setValue(val) {
      if (val == "0000-00-00") {
        this.rawdate = "";
        this.date = this.$moment().format("YYYY-MM-DD");
      } else {
        this.rawdate = this.$moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");
        this.date = this.$moment(val, "YYYY-MM-DD").format("YYYY-MM-DD");
      }
    },
    informValid() {
      this.errormsg2 = "";
    },
    informInvalid(txt) {
      this.errormsg2 = txt;
    },
    validate() {
      let oks = [];
      for (let iRule = 0; iRule < this.rules.length; iRule++) {
        const rule = this.rules[iRule];
        let ok = rule(this.date);
        if (this.$_.isString(ok)) oks.push(ok);
      }
      if (oks.length == 0) {
        this.informValid();
        return true;
      }
      this.informInvalid(oks.join(","));
      return false;
    },
    onfocus(evt) {
      this.$emit("focus", evt);
    }
  }
};
</script>
